import { useCurrentUser } from 'src/hooks/user';

import { usePlatformStaff } from './usePlatformStaff';

export const useCurrentPlatformStaff = () => {
  const { user } = useCurrentUser();
  const { platformStaff, loading } = usePlatformStaff(user?.platformStaff?.id);

  const platformStaffId = platformStaff?.id;
  const isFinancialReportAvailable = platformStaff?.isFinancialReportAvailable || false;
  const isAbleToManagePlatformStaff = platformStaff?.isAbleToManagePlatformStaff || false;

  return {
    platformStaffId,
    isFinancialReportAvailable,
    isAbleToManagePlatformStaff,
    loading,
  };
};
